import React from "react";
import "../styles/index.css";

const RecHeader = () => {
  return (
    <div className="rec-header">
      <div className="rec-logo-wrapper">
        <img
          src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/REC_Logo.jpg"
          alt="REC Limited"
          className="rec-logo"
        />
      </div>

      <div className="rec-title">
        REC CGTE Bonds
      </div>

      <div className="rec-address">
        <b>Address: </b>REC Limited, Plot No. I-4, Sector-29,
        Gurugram, Haryana - 122001
      </div>

      <div className="rec-contact">
        <b>Tel: </b>
        <a
          href="tel:18001802992"
          className="rec-contact-link"
        >
         1800-180-2992
        </a>

        <span className="rec-divider">|</span>
        <b>Email: </b>
        <a
          href="mailto:investorcell@recl.in"
          className="rec-contact-link"
        >
          investorcell@recl.in
        </a>

        <span className="rec-divider">|</span>
        <b>Web: </b>
        <a
          href="https://recindia.nic.in/"
          target="_blank"
          rel="noopener noreferrer"
          className="rec-contact-link"
        >
          www.recindia.nic.in
        </a>
      </div>
    </div>
  );
};

export default RecHeader;